import IButton from '@/components/UI/IButton'
import IInput from '@/components/UI/IInput'
import ICurrentTime from '@/components/UI/ICurrentTime'
import IDurationTime from '@/components/UI/IDurationTime'


export default [
    IButton,
    IInput,
    ICurrentTime,
    IDurationTime
]